export default __webpack_public_path__ + "static/circle2-8705d69c3e57656f8e3f634044175410.png";